import {
  APP_STORE_NAVIGATED,
  FEED_PANEL_SELECTED,
} from 'app/features/success/actionTypes';
import { feed, contentMedia, ActionDetail } from 'app/analytics/helpers';
import { FEED_TITLES, FEED_TYPES } from 'app/analytics/constants/media';
import { pageNameFromRouterPath } from 'app/router/selectors';
import { MIDDLE } from 'app/analytics/constants/positions';
import { commonActionDetail } from 'app/analytics/selectors';
import isIOS from 'app/libs/isIOS';

const success = {
  [FEED_PANEL_SELECTED]: (
    getState,
    {
      payload: {
        id,
        name,
        index,
        feedType = FEED_TYPES.RECOMMENDATION,
        feedTitle = FEED_TITLES.JOURNEY,
      },
    },
  ) => ({
    type: 'track',
    name: 'Feed Panel Selected',
    properties: {
      screenName: pageNameFromRouterPath(getState()),
      positionOfPanelInFeed: index,
      positionOfFeed: index,
      ...contentMedia({
        name,
        id,
      }),
      ...feed({
        feedId: id,
        feedType,
        feedTitle,
      }),
    },
  }),
  [APP_STORE_NAVIGATED]: (
    getState,
    {
      payload: {
        position = MIDDLE,
        appStore = isIOS ? 'apple' : 'googleplay',
        textOfButtonOrLink = appStore,
      },
    },
  ) => ({
    type: 'track',
    name: 'App Store Navigated',
    properties: {
      appStore,
      ...ActionDetail({
        position,
        textOfButtonOrLink,
        ...commonActionDetail(getState()),
      }),
    },
  }),
};

export default success;
